import { useCallback, useContext } from "react"
import NotyfContext from "../contexts/NotyfContext"
import { isBlank } from "../utils/helpers"

export default function useRequestCatcher() {

    const notyf = useContext(NotyfContext)

    const requestCatcher = useCallback(async ({
        id,
        options,
        validator,
        payload: rawPayload,
        disableNotyf = false,
        onSuccessMessage = '',
        requestHandler = null,
        onErrorCallback = null,
        payloadIsObject = false,
        fileUploadHandler = null,
        subjectToValidate = null,
        onSuccessCallback = null,
        onValidatedCallback = null,
    }) => {
        
        try {   
            const unvalidatedPayload = subjectToValidate ?? rawPayload

            if(validator) await validator?.validate?.(unvalidatedPayload)

            await onValidatedCallback?.(unvalidatedPayload, id)

            const payload = rawPayload

            const fetchArguments = (()=>{
                const result = []
                if(payloadIsObject){
                    const callArgument = {}
                    if(id) callArgument['id'] = id
                    if(payload) callArgument['payload'] = payload
                    if(options) callArgument['options'] = options
                    result.push(callArgument)
                }else{
                    if(id) result.push(id)
                    if(payload) result.push(payload)
                    if(options) result.push(options)
                }

                return result
            })()
            
            const result = await requestHandler?.(...fetchArguments)

            if (!isBlank(result)) {
                
                const successMessage = result?.data?.message ?? onSuccessMessage
                !isBlank(successMessage) && !disableNotyf && notyf?.success(successMessage)

                return await onSuccessCallback?.(result)

            }

            return result

        } catch (error) {
            !disableNotyf && notyf?.error(
                error?.response?.data?.message
                ?? error?.message 
                ?? "An error occurred"
            )
            onErrorCallback?.()
            throw error
        }
        
    }, [])

    return requestCatcher
}
